<template>
  <span>
  <Portlet
    :full-height="true"
    :no-padding="true"
    :headSeparator="true"
    :hasFooter="true"
  >
    <template slot="Menu">c
        <router-view name="menu"></router-view>
    </template>
    <template slot="Title">
      <MenuSection/>
    </template>

    <template slot="Options">
      <template>
          <form
            v-on:submit.prevent="onSearch"
            class="portlet-search"
          >
          <router-link tag="a" :to="{name:'LibraryAdvancedSearchQuery', query: $route.query}" :class="`item-right${$route.name == 'LibraryAdvancedSearchResults' ? ' router-link-active' : ''}`">
              <span class="text" style="white-space:nowrap;">Advanced Search</span>
            </router-link>
            <span v-if="!isAdvancedSearch" style="white-space:nowrap;">
              <span class="separator" style="padding: 0 10px;">&nbsp;|&nbsp;</span>
              <input
                v-model="searchTerms"
                ref="searchInput"
                class="portlet-search-input"
                type="text"
                placeholder="Search artist, title or label"
              />
              <button class="portlet-search-toggle" type="submit">
                <i class="fas fa-search"></i>
              </button>
              <a v-on:click.prevent="clearSearch" href="#" class="portlet-search-close">
                <i class="fas fa-times"></i>
              </a>
            </span>
          </form>
          <UploadMultiSearchButton />
          <UploadButton v-if="currentStation.allowTrackUpload || isValidType()" style="margin-left: 7px"/>
      </template>
      <router-view name="pageActions"></router-view>
    </template>

    <template slot="Search">
    </template>

    <template slot="PortletNav">
      <router-view name="pageSubMenu">
      </router-view>
    </template>

    <template slot="Content">
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </template>

    <template slot="">

    </template>

  </Portlet>
    <DuplicateItems v-if="showDuplicateItems"  :showModalStatus="showDuplicateItems" :items="itemsDuplicate" ref="DuplicateItems"/>
</span>
</template>

<script>
import MenuSection from './__MenuSection.vue'

import AdvancedSearchMenu from "./AdvancedSearch/SubMenu.vue";
import Portlet from "@/components/common/Portlet";
import router from "@/router";
import store from "@/store";
import EventBus from "@/eventbus";
import UploadButton from "./UploadButton";
import { mapState, mapActions } from "vuex";
import { HTTP } from "@/utils/http";
import Apis from "@/apis/index";
import DuplicateItems from "@/components/Library/DuplicateItems";
import UploadMultiSearchButton from "@/components/Library/UploadMultiSearchButton.vue";
export default {
  name: "MasterSection",
  router,
  store,
  components: {
    MenuSection,
    AdvancedSearchMenu,
    Portlet,
    UploadButton,
    DuplicateItems,
    UploadMultiSearchButton
  },

  created() {
    EventBus.$on("onTracksDelete", this.removeTrack);
    EventBus.$on("onUploadFile", this.selectFiles);
    EventBus.$on("mediaDuplicatedDetected", this.showDuplicate);
    EventBus.$on('onDuplicateItemsEnded' , this.clean);
  },
  beforeDestroy(){
    EventBus.$off("mediaDuplicatedDetected",this.showDuplicate);
  },
  data() {
    return {
      removeTrackUids: null,
      isRemovingTracks: false,
      filesToUpload: [],
      itemsDuplicate: null,
      searchTerms: null,
      showDuplicateItems: false,
      currentPage: (this.pagination||{page:1}).page || 1
    };
  },
  computed: {
    // ...mapState({
        // pagination(state) {
        //   console.log(state);
        //   if (this.isAdvancedSearch)
        //     return state.advancedSearch.pagination
        //   return state.Search.pagination
        // },
        // isLoading(state){
        //   if (this.isAdvancedSearch)
        //     return state.advancedSearch.isLoading
        //   return state.Search.isLoading
        // }
    // }),
    currentStation() {
      return this.$store.state.currentStation ||{};
    },

    isAdvancedSearch() {
      const { name } = this.$route;
      return (
        name === "LibraryAdvancedSearch" ||
        name === "LibraryAdvancedSearchQuery" ||
        name === "LibraryAdvancedSearchResults"
      );
    }
  },
  mounted() {
    if (this.$route.query.search) {
      this.toggleSearch();
      this.searchTerms = this.$route.query.search;
      this.onSearch();
    }
  },
  methods: {
    clean(){
      this.itemsDuplicate = null;
      this.showDuplicateItems = false;
    },
    showDuplicate(data) {
      console.log(data)
      this.itemsDuplicate = data;
      this.showDuplicateItems = true;
    },
    isValidType() {
      let fileType= this.$route.params.fileType;
      return (fileType || "").toLowerCase() !== "music";
    },
    clearSearch() {
      console.log("ClearSearch")
      if ((this.searchTerms || "") == "")
      {
        console.log("Search Term Already Empty")
        // Do Nothing : already empty
      }
      else
      {
        console.log("Emptying Search Term")
        this.searchTerms="";
        this.onSearch();
        EventBus.$emit("onTracksSearch", null);
      }
    },

    toggleSearch() {
      console.log('toggleSearch')
      //this.$store.commit("onSearchToggle");

      setTimeout(() => {
        if (this.$store.state.viewState.hasSearch) {
          console.log('toggleSearch if')
          this.$refs.searchInput.focus();
        } else {
          console.log('toggleSearch else')
          // this.$router.push({ query: null });
          EventBus.$emit("onTracksSearch", null);
        }
      }, 100);
    },
    onSearch() {
      console.log('onSearch')
      if (this.searchTerms !== this.$route.query.search) {
        this.$router.push({ query: { search: this.searchTerms } });
      }
      if (!this.searchTerms || this.searchTerms.length === 0) {
        return;
      }

      EventBus.$emit("onTracksSearch");
      // this.$store.dispatch('searchTracks', this.searchTerms);
    },
    dropUpload(e) {
      if (
        e &&
        e.dataTransfer &&
        e.dataTransfer.files &&
        e.dataTransfer.files.length
      ) {
        console.log("dropped", e.dataTransfer.files);
        this.filesToUpload = Array.from(e.dataTransfer.files);
        this.$refs.uploadModal.show();
      }
    },
    convertFormatUnit(bytes, decimals = 2) {
      if (bytes === 0) return "0 Bytes";

      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

      const i = Math.floor(Math.log(bytes) / Math.log(k));

      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    }
  },

  watch: {
    // isAdvancedSearch(value) {
    //   if (value === true && this.$store.state.viewState.hasSearch) {
    //     //this.$store.commit("onSearchToggle");
    //   }
    // },
    // currentPage(to) {
    //   EventBus.$emit('onTracksSearch', to);
    // }
  }
};
</script>

<style lang="scss" scoped>
.back-button {
  margin-right: 20px;
  align-self: center;

  i {
    padding: 0;
    font-size: 14px;
  }
}

.title-text {
  align-self: center;
}

// Search
.portlet-search {
  display: flex;
  align-items: center;
justify-content: flex-end;
  .fa-search {
    margin-right: 20px;
    color: var(--COLOR_BRAND);
  }

  .portlet-search-advanced {
    border: 0;
    background-color: transparent;
    margin-left: 20px;
    font-size: 11px;
    font-weight: 600;
    padding: 9px 15px;
    letter-spacing: 0.7px;
    text-transform: uppercase;

    &:hover {
      text-decoration: none;
    }
  }

  .portlet-search-input {
    flex-grow: 1;
    font-size: 14px;
    letter-spacing: 0.2px;
    line-height: 17px;
    color: var(--COLOR_TEXT);
    border-bottom: 1px solid var(--COLOR_BRAND);

    &[value=""] {
      border-bottom: 1px solid var(--COLOR_LIGHT);
    }
    &:focus {
      border-bottom: 1px solid var(--COLOR_BRAND);
    }
  }

  .portlet-search-submit {
    margin-left: 5px;
    text-transform: uppercase;
  }

  .portlet-search-close {

    i {
      transition: color 0.2s ease-in-out;
      font-size: 20px;
    }

    &:not(:hover) {
      i {
        color: #d2d2d2;
      }
    }
  }
}
</style>
